import { render, staticRenderFns } from "./AutoupdateView.vue?vue&type=template&id=be55461e&"
import script from "./AutoupdateView.vue?vue&type=script&lang=js&"
export * from "./AutoupdateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be55461e')) {
      api.createRecord('be55461e', component.options)
    } else {
      api.reload('be55461e', component.options)
    }
    module.hot.accept("./AutoupdateView.vue?vue&type=template&id=be55461e&", function () {
      api.rerender('be55461e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/wordpress/AutoupdateView.vue"
export default component.exports